<template>
    <div class="row">
        <div class="d-md-none slide-popin-modal">
            <slide-popin-modal-filter
                :id="'slide-filters-reviews-modal'"
                :aria-labelledby="'slide-filters-reviews'"
                :with-close-button="false"
            >
                <device-filter-reviews
                    device="mobile"
                    :loading="deviceFilterReviews.loading"
                    :reviews-messages="reviewsMessages"
                    :ratings-filter-check-boxes="ratingsFilterCheckboxes"
                    @change-check-box-ratings-filter="updateRatingsFilterHandler"
                />
            </slide-popin-modal-filter>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
            <div class="d-none d-md-block">
                <device-filter-reviews
                    device="desktop"
                    :loading="deviceFilterReviews.loading"
                    :reviews-messages="reviewsMessages"
                    :ratings-filter-check-boxes="ratingsFilterCheckboxes"
                    @change-check-box-ratings-filter="updateRatingsFilterHandler"
                />
            </div>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
            <device-details-reviews
                :reviews-total-number="deviceDetailsReviews.totalNumber"
                :device-reviews="deviceDetailsReviews.reviews"
                :offset="deviceDetailsReviews.offset"
                :bloc-size="deviceDetailsReviews.blocSize"
                :loading="deviceDetailsReviews.loading"
                :reviews-messages="reviewsMessages"
            />
        </div>
        <div class="col-12">
            <div v-if="hasMoreReviews" class="row text-center mt-1">
                <div class="col-12">
                    <ob1-boutons
                        :is-button="true"
                        :label="reviewsMessages.more"
                        :is-secondary="true"
                        @ob1-boutons-click="getMoreDeviceReviews"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DeviceDetailsReviews from "../../common/devicereviews/DeviceDetailsReviews.vue"
import DeviceFilterReviews from "../../common/devicereviews/DeviceFilterReviews.vue"
import SlidePopinModalFilter from "../../common/selector/fragment/SlidePopinModalFilter.vue"

export default {
    name: 'DeviceFilterAndDetailsReviews',
    components: {DeviceDetailsReviews, DeviceFilterReviews, SlidePopinModalFilter},
    props: {
        deviceDetailsReviews: {
            type: Object,
            required: true
        },
        deviceFilterReviews: {
            type: Object,
            required: true
        },
        reviewsMessages: {
            type: Object,
            required: true
        },
        ratingsFilterCheckboxes: {
            type: Array,
            required: true
        },
    },
    computed: {
        hasMoreReviews() {
            return this.deviceDetailsReviews.offset + this.deviceDetailsReviews.blocSize < this.deviceDetailsReviews.totalNumber
        }
    },
    methods: {
        getMoreDeviceReviews() {
            this.$emit('more-device-reviews');
        },
        updateRatingsFilterHandler(selectedRatingsFilter) {
            this.$emit('update-ratings-filter-handler', selectedRatingsFilter);
        }
    }
}
</script>
